// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"05c0b502b46d5c26abbb","785":"cf6d628c70ab2e767e56"}[chunkId] + ".js";
};